// ──────────────────────────────────────────────────────────────────────────────
// Environment unico, risolto a RUNTIME — la stessa immagine Docker funziona su
// qualunque macchina senza ricompilare (sia il tag :dev che la prod).
//
// Regola per l'URL di Keycloak:
//   - servito da nginx (qualsiasi deploy via immagine: stesso origin, path
//     routing) → `${origin}/auth`  → usa il Keycloak del container locale;
//   - `ng serve` in sviluppo (frontend su :4200, Keycloak su host:porta a parte)
//     → DEV_KEYCLOAK_URL esplicito.
//
// Così non c'è alcun IP/host compilato nel bundle: l'app si auto-riferisce
// all'origin da cui è servita. environment.prod.ts è mantenuto coerente, ma il
// discriminante è il runtime (la porta di ng serve), non la build config —
// angular.json non ha fileReplacements, quindi questo file è l'UNICO usato.
// ──────────────────────────────────────────────────────────────────────────────

// Keycloak usato SOLO durante `ng serve` (sviluppo locale fuori dai container).
// Cambialo qui se il tuo Keycloak di sviluppo è altrove.
const DEV_KEYCLOAK_URL = 'http://192.168.55.235:8080';

// Porte tipiche del dev server Angular (`ng serve`).
const DEV_SERVE_PORTS = new Set(['4200', '4201']);

export function resolveKeycloakUrl(): string {
  const isNgServe =
    typeof location !== 'undefined' && DEV_SERVE_PORTS.has(location.port);
  return isNgServe ? DEV_KEYCLOAK_URL : `${location.origin}/auth`;
}

export const environment = {
  production: false,
  apiBase: '/api/v1',
  keycloakUrl: resolveKeycloakUrl(),
  keycloakRealm: 'saragraph',
  keycloakClientId: 'saragraph-frontend',
};
